import {Model} from '@vuex-orm/core';
import UnitPlan from '@/store/units/UnitPlan';
import {IUnitPlanAttitude} from '@/interfaces/planner/purpose/IUnitPlanAttitude';

// @ts-ignore
export default class UnitPlanAttitude extends Model implements IUnitPlanAttitude{
    static entity = 'unit_plan_attitudes';

    static fields () {
        return {
            id: this.number(0),
            attitude_id: this.number(null),
            unitplan_id: this.number(null),
            cod: this.string('AC00'),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            attitude: this.hasOne('', 'id'),
            unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
        };
    }
}
